import Narrative from './container';

export default Narrative;



// WEBPACK FOOTER //
// ./src/routes/Narrative/index.js